import { Link } from 'react-router-dom';

type Crumb = {
  label: string;
  to?: string;
};

type Props = {
  items: Crumb[];
};

const Breadcrumb = ({ items }: Props) => (
  <nav aria-label="面包屑导航" className="border-b border-background-200 bg-background-100">
    <div className="layout-shell">
      <ol className="flex flex-wrap items-center gap-x-2 gap-y-1 py-3 text-xs text-foreground-500">
        {items.map((item, index) => {
          const isLast = index === items.length - 1;
          return (
            <li key={item.label} className="flex items-center gap-2">
              {item.to && !isLast ? (
                <Link to={item.to} className="transition-colors hover:text-primary-700">
                  {item.label}
                </Link>
              ) : (
                <span className={isLast ? 'line-clamp-1 max-w-[240px] font-medium text-foreground-800' : ''} aria-current={isLast ? 'page' : undefined}>
                  {item.label}
                </span>
              )}
              {!isLast && <i className="ri-arrow-right-s-line text-foreground-400" aria-hidden="true" />}
            </li>
          );
        })}
      </ol>
    </div>
  </nav>
);

export default Breadcrumb;